<p-panel [toggleable]="true" toggler="icon" class="dashboard-card" (onBeforeToggle)="panelToggle()"
         collapseIcon="pi pi-fw pi-chevron-up" expandIcon="pi pi-fw pi-chevron-down"
         [(collapsed)]="dashboardCard.isCollapsed" [transitionOptions]="'200ms'">
<!--<p-panel class="dashboard-card">-->
  <ng-template pTemplate="icons">
    <ng-container *ngIf="dashboardCard.isCollapsed" [ngTemplateOutlet]="panelIcons"></ng-container>
    <ng-container *ngIf="!dashboardCard.isCollapsed" [ngTemplateOutlet]="collapsedPanelIcons"></ng-container>
  </ng-template>
  <ng-template pTemplate="header">
    <div class="row" style="padding: 5px !important; width:100% !important;">
      <div class="col-auto d-flex align-items-center">
        <div class="d-flex align-items-center">
          <h3 style="margin-bottom: 0 !important;" *ngIf="!dashboardCard.isCollapsed">
            <span style="margin-left: 15px;">
              <fa-icon [icon]="['fad', headerIcon]" style="margin-right: 5px;"> </fa-icon>
              <ng-container [ngTemplateOutlet]="cardHeader"></ng-container>
            </span>
          </h3>
          <h3 style="margin-bottom: 0 !important;" *ngIf="dashboardCard.isCollapsed">
            <span style="margin-left: 15px;">
              <fa-icon [icon]="['fad', headerIcon]" style="margin-right: 5px;"> </fa-icon>
              <ng-container [ngTemplateOutlet]="collapsedCardHeader">
              </ng-container>
            </span>
          </h3>
        </div>
      </div>
      <div class="col-md col-sm-12 d-flex justify-content-end" style="padding: 5px; width:100% !important;">
        <ng-container [ngTemplateOutlet]="cardHeaderAction"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="content" class="dashboard-card-body">
    <ng-content></ng-content>
  </ng-template>
</p-panel>
